<script type="text/jsx">
import BuyNow from './buy-now.vue';
import Edit from './edit.vue';
import DeltaEdit from './edit-delta.vue';
import Upgrade from './upgrade.vue';
import ProToBiz from "./pro2biz.vue";
import BizToPro from "./biz2pro.vue";
import Add from "./add.vue";
import Bundle2biz from './bundle2biz.vue';
import Escp2esc from './escp2esc.vue';
import buyTrial from './buy-trial.vue';
import EduToEsc from './edu2esc.vue';
import { isBizPlusContext, isEduSchCmpPlusContext } from '@/plans/ZOOM_MEETING/common/utils';
import { mapGetters } from 'vuex';
import { plansof } from '@/utils/chain';
import { ZOOM_MEETING_SUB_TYPES } from '@/plans/ZOOM_MEETING/common/utils';
import { MIX_BUY_FLOW_UTILS } from '@/common/service/flow/utils';
import { planTypes } from '@/common/constants';
import SingleUsePro from '@/plans/ZOOM_MEETING/config/single-use-pro.vue';
import { pageConfig } from '@/common/service/page-config';
export default {
  props: {
    configPlanTileStatus: {
      type: Object,
      default: () => ({}),
    },
    isAddon: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(['boughtPlans', 'mixBuyPlanType4FlowType', 'migratePlanState', 'getSelectedPlans', 'selectedSingleUsePro']),
    hasBoughtBizPlan() {
      return plansof(this.boughtPlans).category(ZOOM_MEETING_SUB_TYPES.BIZ).get().length;
    },
    hasBoughtEduSchCmpPlan() {
      return plansof(this.boughtPlans).category(ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP).get().length;
    },
    hasSelectedEduSchCmpPlan() {
      return plansof(this.getSelectedPlans).category(ZOOM_MEETING_SUB_TYPES.ZONE_EDU_SCH_CMP).get().length;
    },
  },
  render() {
    const mixBuyPayload = [this.mixBuyPlanType4FlowType, planTypes.ZOOM_MEETING];
    const context = {...{ props: { ...this.$attrs, ...this.$props }, on: { ...this.$listeners }}};
    // webinar one time
    if (this.selectedSingleUsePro && !this.hasSelectedEduSchCmpPlan) return <SingleUsePro {...context}/>;
    if (this.$context.is.upgrade) return <Upgrade {...context}/>;
    if (this.migratePlanState.is.bundle2biz) return <Bundle2biz {...context} />;
    if (this.migratePlanState.is.escp2esc) return <Escp2esc {...context} />;
    if (this.$context.is.edit) {
      if (this.$context.is.delta || (this.$context.is.modal && pageConfig.addQty > 0)) return <DeltaEdit {...context} />;
      // TODO may meet unexpected issues, maybe Add2Cart is better
      if (isBizPlusContext && !this.hasBoughtBizPlan) return <Add {...context}/>;
      if (isEduSchCmpPlusContext && !this.hasBoughtEduSchCmpPlan) return <Add {...context}/>;
      return <Edit {...context}/>;
    }
    if (this.$context.is.pro2biz) return <ProToBiz {...context}/>;
    if (this.$context.is.add2cart) return <Add {...context}/>;
    if (this.$context.is.biz2pro) {
      return <BizToPro {...context} />;
    }

    // MIX_BUY
    if (this.$context.is.mixBuy) {
      if (MIX_BUY_FLOW_UTILS.planIsAdd2Cart(...mixBuyPayload)) {
        return <Add on={this.$listeners} />;
      }

      if (MIX_BUY_FLOW_UTILS.planIsEdit(...mixBuyPayload)) {
        return <Edit {...context}/>;
      }
    }
    // BUY TRIAL
    if (this.$context.is.buyTrial && pageConfig.editConfig?.planType === planTypes.ZOOM_MEETING) {
      return <buyTrial {...context}/>;
    }

    if (this.$context.is.edu2esc) {
      return <EduToEsc {...context} />;
    }

    return <BuyNow {...context}/>;
  },
};
</script>
